import { Book } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import Button from '@components/button'
import PopupToast from '@components/custom-toast'
import Empty from '@components/empty'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import BookInfo from './component/bookInfo'
import BookCardLoader from './loader/bookCardLoader'
import { BookGrid, BookListContainer } from './style'

const BookListing: React.FC = () => {
  const navigate = useNavigate()
  const [deleteInfo, setDeleteInfo] = useState<any>({
    loading: false,
    deleteId: null,
    visible: false,
  })
  const { data: user } = useSelector((state: any) => state.user)
  const [isFetching, setIsFetching] = useState(false)
  const {
    items: books,
    loading,
    totalPages,
    page,
  } = useSelector((state: any) => state.userBooks)
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    userId: user?.id,
  })
  const fetchBookListing = async (action: any, params: any) => {
    await Book.getBooks(action, params, 'userBooks').catch(() => {})
  }

  useEffect(() => {
    fetchBookListing('set', params)
  }, [user?.id])

  const handleEdit = (book: any) => {
    navigate(`/books/update-book/${book?.id}`, { state: book })
  }

  const handleDelete = async () => {
    setDeleteInfo((prev) => ({ ...prev, loading: true }))

    await Book.deleteBook(deleteInfo?.deleteId, 'userBooks')
      .then(() => {
        setDeleteInfo((prev) => ({
          ...prev,
          deleteId: null,
          visible: false,
          loading: true,
        }))
      })
      .catch(() => {})
      .finally(() => {
        setDeleteInfo((prev) => ({
          ...prev,
          deleteId: null,
          visible: false,
          loading: false,
        }))
      })
  }

  return (
    <>
      <BackNavigation title="Your Books" />

      <>
        {!loading && books.length === 0 && !isFetching ? (
          <Empty
            src="noBook"
            title="No books added yet."
            description="Add books to allow other users to borrow."
          />
        ) : (
          <BookListContainer>
            <BookGrid>
              {!!loading
                ? Array(9)
                    .fill(0)
                    .map((_, index) => (
                      <BookCardLoader key={index.toString()} />
                    ))
                : books.map((book: any, index: number) => (
                    <BookInfo
                      key={index.toString()}
                      book={book}
                      handleView={(book: any) => {
                        navigate(`/books/my-books/${book.name}/${book.id}`)
                      }}
                      handleEdit={handleEdit}
                      handleDelete={() => {
                        setDeleteInfo({
                          ...deleteInfo,
                          visible: true,
                          deleteId: book?.id,
                        })
                      }}
                    />
                  ))}
              {!!isFetching && (
                <>
                  {Array(2)
                    .fill(0)
                    .map((_, index) => (
                      <BookCardLoader key={index.toString()} />
                    ))}
                </>
              )}
            </BookGrid>

            {page < totalPages && books.length > 0 && (
              <Button
                title="Load More..."
                type="button"
                styleButton="width: fit-content; margin: 16px auto;"
                onClick={async () => {
                  const updateParams = {
                    ...params,
                    page: params?.page + 1,
                  }
                  setParams(updateParams)

                  if (updateParams?.page <= totalPages) {
                    setIsFetching(true)
                    await fetchBookListing('append', updateParams)
                      .catch(() => {})
                      .finally(() => {
                        setIsFetching(false)
                      })
                  }
                }}
              />
            )}
          </BookListContainer>
        )}
        <PopupToast
          isOpen={deleteInfo?.visible}
          content="Are you sure you want to Delete ?"
          onClick={handleDelete}
          onClose={() => {
            setDeleteInfo({
              loading: false,
              deleteId: null,
              visible: false,
            })
          }}
          image={'deactivate'}
          buttonText="Yes"
          cancelText={'No'}
          loading={deleteInfo.loading}
        />
      </>
    </>
  )
}

export default BookListing
